import React from 'react';
import './programLang.scss';

const ProgramLang = () => {
	return (
		<div className="container">
			<h2 id="header" style={{'background-color': '#BABABA', padding: '4px 20px'}}>Front</h2>
			<div className="icons">
				<div className="icon-sector">
					<i class="devicon-html5-plain colored" id="icon"></i>
					<p id="text" className="icon-text">
						Html
					</p>
				</div>
				<div className="icon-sector">
					<i class="devicon-css3-plain colored" id="icon"></i>
					<p id="text">Css</p>
				</div>
				<div className="icon-sector">
					<i class="devicon-bootstrap-plain" id="icon"></i>
					<p id="text">BootStrap</p>
				</div>
				<div className="icon-sector">
					<i class="devicon-sass-original" id="icon"></i>
					<p id="text">Sass</p>
				</div>

				<div className="icon-sector">
					<i class="devicon-react-original colored" id="icon"></i>
					<p id="text">React/React-native</p>
				</div>
				<div className="icon-sector">
					<i class="devicon-android-plain" id="icon"></i>
					<p id="text">Kotlin</p>
				</div>
				<div className="icon-sector">
					<span
						class="iconify"
						data-icon="simple-icons:redux"
						data-inline="false"
						id="icon"
					></span>
					<p id="text">Redux</p>
				</div>
			</div>
			<h2 id="header" style={{'background-color': '#BABABA', padding: '4px 20px'}}>Back</h2>
			<div className="icons">
				<div className="icon-sector">
					<i class="devicon-javascript-plain colored" id="icon"></i>
					<p id="text">Javascript</p>
				</div>

				<div className="icon-sector">
					<i class="devicon-nodejs-plain-wordmark" id="icon"></i>
					<p id="text">NodeJS</p>
				</div>
				<div className="icon-sector">
					<i class="devicon-express-original" id="icon"></i>
					<p id="text">Express/Koa</p>
				</div>
				<div className="icon-sector">
					<i class="devicon-java-plain" id="icon"></i>
					<p id="text">Java</p>
				</div>
				<div className="icon-sector">
					<i class="devicon-go-plain colored" id="icon"></i>
					<p id="text">GoLang</p>
				</div>
			</div>
			<h2 id="header" style={{'background-color': '#BABABA', padding: '4px 20px'}}>Data</h2>
				
			<div className="icons" style={{'padding-bottom': '100px'}}>
				<div className="icon-sector">
					<span
						class="iconify"
						data-icon="fa-brands:r-project"
						data-inline="false"
						id="icon"
					></span>
					<p id="text">R studio</p>
				</div>
				<div className="icon-sector">
					<i class="devicon-mongodb-plain colored" id="icon"></i>
					<p id="text">MongoDB / RealmDB</p>
				</div>
				<div className="icon-sector">
					<i class="devicon-mysql-plain colored" id="icon"></i>
					<p id="text">MySql</p>
				</div>
			</div>
		</div>
	);
};

export default ProgramLang;